import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import type { FieldValidation } from '@rjsf/utils';
import { PasswordGenerator } from './PasswordGenerator';

export const PasswordGeneratorFieldExtension = FormFieldBlueprint.make({
  name: 'password-generator',
  params: {
    field: async () =>
      createFormField({
        name: 'PasswordGenerator',
        component: PasswordGenerator as any,
        validation: (value: string | undefined, validation: FieldValidation) => {
          if (!value?.trim()) {
            validation.addError(
              'Password generation failed or returned empty value',
            );
          }
        },
        schema: makeFieldSchema({
          output: z => z.string(),
          uiOptions: z =>
            z.object({
              length: z
                .number()
                .optional()
                .describe('Generated password length (default 16)'),
              charset: z
                .string()
                .optional()
                .describe(
                  'Custom character set. When set, the other charset flags are ignored',
                ),
              uppercase: z
                .boolean()
                .optional()
                .describe('Include uppercase letters (default true)'),
              lowercase: z
                .boolean()
                .optional()
                .describe('Include lowercase letters (default true)'),
              numbers: z
                .boolean()
                .optional()
                .describe('Include numbers (default true)'),
              symbols: z
                .boolean()
                .optional()
                .describe('Include symbols (default false)'),
              hidden: z
                .boolean()
                .optional()
                .describe('Hide the generated password field in the form'),
            }),
        }),
      }),
  },
});
